export class SendMessageToAIRequest {
    'id';
    'messages';
    'trigger';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "messages",
            "baseName": "messages",
            "type": "Array<any>",
            "format": ""
        },
        {
            "name": "trigger",
            "baseName": "trigger",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SendMessageToAIRequest.attributeTypeMap;
    }
    constructor() {
    }
}
